import React from "react";
import Link from "next/link";
import upperFirst from "lodash/upperFirst";
import classnames from "classnames";
import { useRouter } from "next/router";

const reduceConfigNodes = ({ config, activePath, depth = 1, onClick }) =>
  Object.keys(config).map((key) => {
    const nodeConfig = config[key];
    const keyLabel = upperFirst(key.replace(/-/g, " "));
    const isLink = nodeConfig.href;
    if (isLink) {
      const isActive = activePath === nodeConfig.as;
      return !nodeConfig.disabled ? (
        <Link {...nodeConfig} key={nodeConfig.as}>
          <a
            onClick={onClick}
            id={nodeConfig.as}
            className={classnames(
              `link ${
                nodeConfig.as
              } decoration--hover db w-100 pv2 fw5 bg-white--hover f${
                3 + depth
              }`,
              {
                "ph2": depth > 2,
                "color-text--primary": !isActive,
                "underline fw6 color-primary link__decoration--hover": isActive
              }
            )}
          >
            {keyLabel}
          </a>
        </Link>
      ) : (
        <div
          key={nodeConfig.as}
          className={classnames(
            `db w-100 pv2 fw5 cursor-not-allowed black-40 f${3 + depth}`,
            {
              ph2: depth > 2
            }
          )}
        >
          {keyLabel}
        </div>
      );
    } else if (typeof nodeConfig === "object") {
      return (
        <div
          className={classnames(`w-100 ${key}`, {
            "pv3 bb hairline-1": depth === 1,
            "pt2": depth > 1
          })}
          key={key}
        >
          <div
            className={classnames(`f${3 + depth}`, {
              "fw6 pb1": depth === 1,
              "black-80 fw5 pb1": depth > 1
            })}
          >
            {keyLabel}
          </div>
          {reduceConfigNodes({
            config: nodeConfig,
            activePath,
            depth: depth + 1,
            onClick
          })}
        </div>
      );
    }
  }, []);

const Nav = ({ config, onClick }) => {
  const { asPath } = useRouter();
  const nodes = reduceConfigNodes({ config, activePath: asPath, onClick });

  return <ul className="list ma0 pa0 w-100 flex flex-column ph3">{nodes}</ul>;
};

export default Nav;
